'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Container } from '@/components/container/container';
import { Button } from '@/components/ui/button/button';
import { Heading } from '@/components/ui/heading/heading';
import { useStaleChunkReload } from '@/utils/staleChunkReload';

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // A chunk the deploy removed: one full navigation to the same URL, no screen.
  const reloading = useStaleChunkReload(error);

  useEffect(() => {
    console.error('Blog error:', error);
  }, [error]);

  if (reloading) return null;

  return (
    <main className="min-h-screen flex items-center justify-center">
      <Container className="text-center">
        <Heading variant="h1" className="mb-4">
          Nie udało się załadować bloga
        </Heading>
        <p className="text-neutral-400 mb-8 max-w-md mx-auto">
          Przepraszamy, wystąpił problem podczas ładowania treści bloga. Spróbuj ponownie później.
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={reset} variant="primary">
            Spróbuj ponownie
          </Button>
          <Button as={Link} href="/" variant="secondary">
            Strona główna
          </Button>
        </div>
      </Container>
    </main>
  );
}
